/**
 * Created by jv on 2019-11-22 (10:42).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

const resourceIcons = require.context("Images/business-model/resource-icons", false, /\.svg$/);

require("Styles/components/event-panel.scss");

class EventPanel
{
    constructor(options)
    {
        if (utils.isNull(options)) options = {};

        this._event = options.event;
        this.appendTo = $(options.appendTo);
    }

    get event()
    {
        return this._event;
    }

    set event(event)
    {
        this._event = event;
        this.render();
    }

    render()
    {
        if (utils.isNull(this.event)) return;

        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.destroy();
        }

        this.$element = $("<div class='event-panel'></div>");
        this.$element.data("event-type", this.event.type);

        log.debug("Setting up event panel for event - %o", this.event);

        let $eventPanelTop = $("<div class='event-panel__top'></div>");
        let event = LanguageManager.getValueForKey("event.title");
        let title = LanguageManager.getValueForKey("event." + this.event.type + ".title");

        $eventPanelTop.append(`<h3 class="event-panel__title">${event}</h3>`);
        $eventPanelTop.append(`<h4 class="event-panel__subtitle">${title}</h4>`);

        let description = LanguageManager.getValueForKey("event." + this.event.type + ".description");

        description = description.replaceAll("{coins-icon}", this.getCoinsIcon());

        if (utils.isNotNull(this.event.jsonData))
        {
            if (this.event.type === "tax")
            {
                description = description.replaceAll("{factory-count}", this.event.jsonData.factoryCount);
            }
            else if (this.event.type === "new-materials")
            {
                let resources = this.event.jsonData;

                description += "<br /><br />";

                for (let resource in resources)
                {
                    let amount = resources[resource];

                    for (let i = 0; i < amount; ++i)
                    {
                        description += "<img src='" + resourceIcons("./resource_" + resource + ".svg") + "'/>";
                    }
                }
            }
        }

        $eventPanelTop.append(description);

        let ok = LanguageManager.getValueForKey("modal.buttons.ok");
        let $closeBtn = $("<button class='btn my-dialog-close-btn' type='button'>" + ok + "</button>");

        $eventPanelTop.append($closeBtn);

        this.$element.append($eventPanelTop);

        this.$element.appendTo(this.appendTo);
    }

    getCoinsIcon()
    {
        return "<img src='" + resourceIcons("./coins.svg") + "' />";
    }

    destroy()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.$element.remove();
        }
    }

    show()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.$element.show();
        }
    }

    hide()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.$element.hide();
        }
    }
}

export default EventPanel;



// WEBPACK FOOTER //
// ./app/js/components/game/components/event-panel.js